/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import { useCallback } from "react";
import { useFloodgateFeature } from "hooks/useFloodgateFeature";

type TrialToPaidKeys = { control: string; trial_to_paid: string };
type TrialToPaidT = (
  keys: TrialToPaidKeys,
  opts?: Record<string, unknown>
) => string;

// I18n facade that picks between two translation keys based on the
// firefly_pro_trial_to_paid_enabled Floodgate flag, so copy matches whichever
// Firefly Pro offer (see useOfferId) the user will actually be checked out with.
export const useTrialToPaidI18n = (): TrialToPaidT => {
  const isTrialToPaid = useFloodgateFeature(
    "firefly_pro_trial_to_paid_enabled"
  );
  return useCallback<TrialToPaidT>(
    (keys, opts = {}) =>
      I18n.t(isTrialToPaid ? keys.trial_to_paid : keys.control, opts),
    [isTrialToPaid]
  );
};
